// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__aCMc+","fadeIn":"Loading_fadeIn__Nr8vo","loadingText":"Loading_loadingText__WbfpZ"};